import { useTranslation } from 'react-i18next';
import { Table } from '@sentara-health/optimahealth_web';
import { formatISODateToMDY } from 'common';
const AuthorizationDetailsTable: React.FC<any> = ({ authDetails }) => {
  const { t } = useTranslation();
  return (
    <div className="table-responsive overflow-auto pb-2">
      <Table
        className={'print authorizations-table'}
        rows={[
          [
            {
              text: (
                <th scope='col' data-testid="memberNameLabel">
                  {t('common.memberNameWithColon')}
                </th>
              ),
            },
            {
              text: (
                <span data-testid="memberName">
                  {authDetails?.memberFullName}
                </span>
              ),
            },
          ],
          [
            {
              text: (
                <th scope="col" data-testid="memberIdLabel">
                  {t('common.memberIdWithColon')}
                </th>
              ),
            },
            {
              text: <span data-testid="memberId">{authDetails?.memberId}</span>,
            },
          ],
          [
            {
              text: (
                <th scope='col' data-testid="authNumberLabel">
                  {t('authorizationDetails.authorizationNumber')}
                </th>
              ),
            },
            {
              text: (
                <span data-testid="authNumber">
                  {authDetails?.authorizationNumber}
                </span>
              ),
            },
          ],
          [
            {
              text: (
                <th scope='col' data-testid="liabilityTypeLabel">
                  {t('authorizationDetails.liabilityType')}
                </th>
              ),
            },
            {
              text: (
                <span data-testid="liabilityType">
                  {authDetails?.liability}
                </span>
              ),
            },
          ],
          [
            {
              text: (
                <th scope='col' data-testid="effectiveDateLabel">
                  {t('authorizationDetails.effectiveDate')}
                </th>
              ),
            },
            {
              text: (
                <span data-testid="effectiveDate">
                  {authDetails?.effectiveDate
                    ? formatISODateToMDY(authDetails?.effectiveDate)
                    : ''}
                </span>
              ),
            },
          ],
          [
            {
              text: (
                <th scope='col' data-testid="expirationDateLabel">
                  {t('authorizationDetails.expirationDate')}
                </th>
              ),
            },
            {
              text: (
                <span data-testid="expirationDate">
                  {authDetails?.expirationDate
                    ? formatISODateToMDY(authDetails?.expirationDate)
                    : ''}
                </span>
              ),
            },
          ],
          [
            {
              text: (
                <th scope='col' data-testid="doctorReferredToLabel">
                  {t('authorizationDetails.doctorReferredTo')}
                </th>
              ),
            },
            {
              text: (
                <span data-testid="doctorReferredTo">
                  {authDetails?.referredToProviderName}
                </span>
              ),
            },
          ],
          [
            {
              text: (
                <th scope='col' data-testid="referredToPracticeLabel">
                  {t('authorizationDetails.referredToPractice')}
                </th>
              ),
            },
            {
              text: (
                <span data-testid="referredToPractice">
                  {authDetails?.referredToPracticeName}
                </span>
              ),
            },
          ],
          [
            {
              text: (
                <th scope='col' data-testid="docReferredByLabel">
                  {t('authorizationDetails.doctorReferredBy')}
                </th>
              ),
            },
            {
              text: (
                <span data-testid="docReferredBy">
                  {authDetails?.referredBy}
                </span>
              ),
            },
          ],
          [
            {
              text: (
                <th scope='col' data-testid="authorizedVisitsLabel">
                  {t('authorizationDetails.numberOfAuthorizedVisits')}
                </th>
              ),
            },
            {
              text: (
                <span data-testid="authorizedVisits">
                  {authDetails?.authorizedVisits}
                </span>
              ),
            },
          ],
          [
            {
              text: (
                <th scope='col' data-testid="numberOfClaimedVisitsLabel">
                  {t('authorizationDetails.NumberOfClaimedVisits')}
                </th>
              ),
            },
            {
              text: (
                <span data-testid="numberOfClaimedVisits">
                  {authDetails?.claimedVisits}
                </span>
              ),
            },
          ],
        ]}
      />
    </div>
  );
};

export default AuthorizationDetailsTable;
